import type { CaseStatus, ExtractionStatus } from '@vrzl/database';
import type { VStatusIconProps } from '@vrzl/ui';
import { Check, LoaderCircle, Timer, X, type LucideIcon } from 'lucide-react';

// "Event" in UI = "Case" in backend
export const statusBadgeColor: Record<CaseStatus, 'info' | 'warning' | 'neutral'> = {
  OPEN: 'info',
  EXPIRED: 'warning',
  CLOSED: 'neutral',
};

export const statusLabels: Record<CaseStatus, string> = {
  OPEN: 'Open',
  EXPIRED: 'Verlopen',
  CLOSED: 'Afgesloten',
};

export const extractionStatusLabels: Record<ExtractionStatus, string> = {
  QUEUED: 'Uitlezen gepland',
  IN_PROGRESS: 'Wordt uitgelezen',
  COMPLETED: 'Uitgelezen',
  FAILED: 'Uitlezen mislukt',
};

export const extractionStatusIcon: Record<
  ExtractionStatus,
  { icon: LucideIcon; tone: NonNullable<VStatusIconProps['tone']>; spin?: boolean }
> = {
  QUEUED: { icon: Timer, tone: 'neutral' },
  IN_PROGRESS: { icon: LoaderCircle, tone: 'ghost', spin: true },
  COMPLETED: { icon: Check, tone: 'success' },
  FAILED: { icon: X, tone: 'error' },
};

export const extractionStatusDescriptions: Record<ExtractionStatus, string> = {
  QUEUED: 'Het uitlezen van dit evenement staat in de wachtrij.',
  IN_PROGRESS: 'Het evenement wordt op dit moment uitgelezen.',
  COMPLETED: 'Het evenement is succesvol uitgelezen.',
  FAILED: 'Er is een probleem opgetreden bij het uitlezen van dit evenement.',
};
